
import React from 'react';
import {RADIO_SINGLE_RANDOM_VALUE, RadioButton} from "../prm/radio-button";
import { Name } from "../prm/name";
import { Text, dobValidator, mmddyyyyValidator, isOver18Validator } from "../prm/text";
import { FlowRender } from "../flow-render";
import { GreyBox } from "../../client/funcs/utils";
import { StateOptionMenu } from '../prm/state-menu';
import {OptionMenu} from "../prm/option-menu";

const pagePrefix = "trusted_0_";

const RELATIONSHIP = new OptionMenu(
  new Name(pagePrefix + "relationship"), [
    new Name("spouse", "Spouse"),
    new Name("partner", "Partner"),
    new Name("child", "Child"),
    new Name("parent", "Parent"),
    new Name("sibling", "Sibling"),
    new Name("friend", "Friend"),
    new Name("other", "Other"),
  ], true);

class TrustedContact extends FlowRender {

  constructor(index) {
    super(index, []);

    this.create_params(pagePrefix);
    this.url = "trusted_contact";
  }

  create_params = prefix => {
    this[prefix] = {};

    // decline checkbox
    const decline_checkbox = new RadioButton(
      new Name("decline_checkbox"),
      [ new Name("decline") ],
      [], RADIO_SINGLE_RANDOM_VALUE);
    decline_checkbox.setCallback(this.onChange);
    decline_checkbox.do_checkbox = true;
    this.prmList.push(decline_checkbox);
    this[prefix].decline_checkbox = decline_checkbox;

    RELATIONSHIP.onChangeCallback = this.onChange;
    this.prmList.push(RELATIONSHIP);
    this[prefix].relationship = RELATIONSHIP;

    // trusted first name prm
    const trusted_first_name = new Text(
      new Name(pagePrefix + "first_name", "Trusted_First_Name"),
      null, { path: "name.firstName" });
    trusted_first_name.onAction = this.onTextEdit;
    this.prmList.push(trusted_first_name);
    this[prefix].trusted_first_name = trusted_first_name;

    // trusted last name prm
    const trusted_last_name = new Text(
      new Name(pagePrefix + "last_name", "Trusted_Last_Name"),
    null, { path: "name.firstName" });
    trusted_last_name.onAction = this.onTextEdit;
    this.prmList.push(trusted_last_name);
    this[prefix].trusted_last_name = trusted_last_name;

    // trusted dob prm
    const trusted_dob = new Text(
      new Name(pagePrefix + "dob", "Trusted_DOB"), null,
      { path: "date.past", arg0: 40, arg1: 18 });
    trusted_dob.onAction = this.onTextEdit;
    trusted_dob.hint = "MM/DD/YYYY";
    trusted_dob.validator = dobValidator;
    trusted_dob.blurValidator = mmddyyyyValidator;
    this.prmList.push(trusted_dob);
    this[prefix].trusted_dob = trusted_dob;

    // trusted phone prm
    const trusted_phone = new Text(
      new Name(pagePrefix + "phone", "Trusted_Phone"), null,
      { path: "phone.phoneNumber" });
    trusted_phone.onAction = this.onTextEdit;
    this.prmList.push(trusted_phone);
    this[prefix].trusted_phone = trusted_phone;

    // trusted email prm
    const trusted_email = new Text(
      new Name(pagePrefix + "email", "Trusted_Email" ), null,
      { path: "internet.email" });
    trusted_email.onAction = this.onTextEdit;
    this.prmList.push(trusted_email);
    this[prefix].trusted_email = trusted_email;

    // trusted street prm
    const trusted_street = new Text(
      new Name(pagePrefix + "street", "Trusted_Street"), null,
      { path: "address.streetAddress" });
    trusted_street.onAction = this.onTextEdit;
    this.prmList.push(trusted_street);
    this[prefix].trusted_street = trusted_street;

    // trusted city prm
    const trusted_city = new Text(
      new Name(pagePrefix + "city", "Trusted_City"), null,
      { path: "address.city" });
    trusted_city.onAction = this.onTextEdit;
    this.prmList.push(trusted_city);
    this[prefix].trusted_city = trusted_city;

    // trusted state prm
    const trusted_state = new StateOptionMenu(new Name(pagePrefix + "state", "Trusted_State"));
    this.prmList.push(trusted_state)
    this[prefix].trusted_state = trusted_state;

    // trusted zip prm
    const trusted_zip = new Text(
      new Name(pagePrefix + "zip", "Trusted_Zip"), null,
      { path: "address.zipCode" });
    trusted_zip.onAction = this.onTextEdit;
    this.prmList.push(trusted_zip);
    this[prefix].trusted_zip = trusted_zip;
  };

  /** Called after a text entry is finished editing. */
  onTextEdit = component => {
    const newState = Object.assign({}, component.state);
    component.setState(newState);
  };

  onChange = (component, newState, prm) => {
    const decline_check = this[pagePrefix].decline_checkbox;
    const checked = !!decline_check.getValue(newState);
    this[pagePrefix].relationship.setDisabled(newState, checked);
    this[pagePrefix].trusted_first_name.setDisabled(newState, checked);
    this[pagePrefix].trusted_last_name.setDisabled(newState, checked);
    this[pagePrefix].trusted_city.setDisabled(newState, checked);
    this[pagePrefix].trusted_email.setDisabled(newState, checked);
    this[pagePrefix].trusted_dob.setDisabled(newState, checked);
    this[pagePrefix].trusted_phone.setDisabled(newState, checked);
    this[pagePrefix].trusted_state.setDisabled(newState, checked);
    this[pagePrefix].trusted_street.setDisabled(newState, checked);
    this[pagePrefix].trusted_zip.setDisabled(newState, checked);
  }

  canNavigateNext(component) {
    const isDeclineSelected = this[pagePrefix].decline_checkbox.isSelected(component.state, 0);

    // validation check if form is required
    if (!isDeclineSelected) {
        const highlight_rects = [];

        this.prmList.forEach((prm) => {
          if (prm.type === "Text") {
            prm.isFilledElseHighlight(component.state, highlight_rects);

            if (prm.name.id === this[pagePrefix].trusted_dob.name.id) {
                component.setState({ isDobOver18: !isOver18Validator(prm.getValue(component.state)) })
            }
          }
        });
    
        if (highlight_rects.length > 0) {
          component.setState({ highlight_rects });
          return null;
        }
    }

    /*if (is_ira_rollover(component.getOnboardingData())) {
      return component.getRootUrl() + "/roll_over_attestation";
    }*/

    return component.getRootUrl() + "/authorization_0";
  }

  render = component => {
    const container_style = {
      margin: "auto",
      width: "50%"
    };
    const input_style = {
      width: "100%",
    };
    // const checkbox_style = {
    //   transform: "scale(1.2) translate(0, 0.2rem)",
    // };

    const padding = "1rem";

    const declineLabel = (
        <div>
            <b><span>Decline. You can add someone later.</span></b>
        </div>
    )


    const form = (
      <div>
        <div style={{fontSize: "1.5rem"}}>
          Would you like to add a trusted contact to your account in case something were to happen?
        </div>
        <div style={{paddingTop: "1rem", display: "flex", alignItems: "center", justifyContent:'space-between'}}>
          <div>
              {this[pagePrefix].decline_checkbox.renderCheckboxWithInfo(0, component, declineLabel)}
              {/* <div style={{paddingLeft: "2rem"}}>
              <b><span>Decline.  You can add someone later.</span></b>
              </div> */}
          </div>
        </div>
        <div style={{paddingTop: "2rem"}}>
          <b>Must be a U.S. resident</b>
          <GreyBox>
            {this[pagePrefix].relationship.renderMenuDiv(component, input_style, "Relationship")}
            {this[pagePrefix].trusted_first_name.renderInputDiv(component, input_style, "First Name")}
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_last_name.renderInputDiv(component, input_style, "Last Name")}
            </div>
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_dob.renderInputDiv(component, input_style, "Date of Birth")}
              {component.state.isDobOver18 && <b style={{color: 'red'}}>Must be an adult over 18</b>}
            </div>
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_phone.renderInputDiv(component, input_style, "Phone Number")}
            </div>
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_email.renderInputDiv(component, input_style, "Email Address")}
            </div>
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_street.renderInputDiv(component, input_style, "Street Address")}
            </div>
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_city.renderInputDiv(component, input_style, "City")}
            </div>
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_state.renderMenuDiv(component, input_style, "State")}
            </div>
            <div style={{paddingTop: padding}}>
              {this[pagePrefix].trusted_zip.renderInputDiv(component, input_style, "Zip")}
            </div>
          </GreyBox>
        </div>
      </div>
    )

    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Trusted Contact (Optional)", "50%", "952142244")}
        { this.renderProgress(component) }
        <section className={"section"} style={{paddingTop: "1rem"}}>
          <div className="divgrid-container-responsive" style={container_style}>
            {form}
          </div>
        </section>
        {this.renderNextButtonRow(component, true) }
      </div>
    );
  }
}

export { TrustedContact };
